import { NgModule } from '@angular/core';
import { LoadingIndicatorComponent } from './loading-indicator.component';
import { ProgressBarComponent } from './progress-bar.component';

@NgModule({
  exports: [LoadingIndicatorComponent, ProgressBarComponent],
  imports: [LoadingIndicatorComponent, ProgressBarComponent],
})
export class FmntsProgressIndicatorModule {}
